import Modal from './Modal'

import './style/css'

export default Modal
